import React from 'react';

const RedireactionComponent = () => {
  return (
    <div>
      <h1>Redirect Component</h1>
    </div>
  );
}

export default RedireactionComponent;


